
/* injects from baggage-loader */
require('./style.styl');

import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

export default class URLPart extends React.Component {
  static propTypes = {
    index: PropTypes.number,
    type: PropTypes.string,
    value: PropTypes.string,
    active: PropTypes.bool,
    disabled: PropTypes.bool,
    onClick: PropTypes.func
  }

  render() {
    const {type, value, active, disabled} = this.props

    const classNames = classnames('url-part_token', {
      'is-active': active,
      'is-disabled': disabled
    })

    if (!value) return null

    return (
      <div className='url-part'>
        {this.getPrefix()}
        <span className={classNames} onClick={this.onClick}>
          {type ? `${type}=` : ''}{value}
        </span>
      </div>
    )
  }

  onClick = () => {
    const {onClick, type, value, disabled} = this.props
    if (disabled) return

    onClick && onClick(type, value)
  }

  getPrefix() {
    const {index} = this.props

    if (index === 0) {
      return '?'
    } else if (index > 0) {
      return '&'
    }
  }
}



// WEBPACK FOOTER //
// ./client/components/URLPart/index.js